import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ProblemSection from "@/components/ProblemSection";
import SolutionSection from "@/components/SolutionSection";
import WhyNowSection from "@/components/WhyNowSection";
import PropertyTypesSection from "@/components/PropertyTypesSection";
import FeaturesSection from "@/components/FeaturesSection";
import TrustSection from "@/components/TrustSection";
import GallerySection from "@/components/GallerySection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import InvestmentCalculator from "@/components/InvestmentCalculator";
import ContactFormSection from "@/components/ContactFormSection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO />
      <Header />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <WhyNowSection />
        <PropertyTypesSection />
        <FeaturesSection />
        <TrustSection />
        <GallerySection />
        <TestimonialsSection />
        <FAQSection />
        <InvestmentCalculator />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
}
